import { loggerFactory } from "@sky-it-livedata-libraries/livedata-commons";

const logger = loggerFactory();
export class WidgetError<T extends string> extends Error {
  name: T;
  message: string;
  data: any;
  
  constructor({
    name,
    message,
    data
  }: {
    name: T;
    message: string;
    data?: any;
  }) {
    super();
    this.name = name;
    this.message = message;
    this.data = data;

    logger.error(`Error ${name}: ${message}. Data: ${JSON.stringify(data)}`);
  }
}

export type ErrorName =
| 'NO_VALID_DATA';
